import axiosInstance from "../utils/axios";

// Rows are written by the order pipeline, so this module is read + delete only.
const path = "admin/failed-price-validations";

export const GetFailedPriceValidationList = async (values) => {
    return await axiosInstance().post(`${path}/list`, values);
}

export const GetFailedPriceValidationDetail = async (values) => {
    return await axiosInstance().post(`${path}/get-single`, values);
}

export const GetFailedPriceValidationStats = async (values) => {
    return await axiosInstance().post(`${path}/stats`, values);
}

export const DeleteFailedPriceValidation = async (values) => {
    return await axiosInstance().post(`${path}/delete`, values);
}

export const DeleteManyFailedPriceValidations = async (values) => {
    return await axiosInstance().post(`${path}/delete-many`, values);
}
